import { observable } from 'mobx';

import { Model, App, AppRegistry, ModelRegistry } from 'core';

import { ProjectModel, ProjectArrayApp } from 'apps/project/app';

export class ProcessMonitorModel extends Model {
  static registryName = 'ProcessMonitorModel';
  static ModelProps = {
    pendingOperationProjects: [ProjectModel],
  };

  @observable id;
  @observable pendingOperationProjects = [];
}
ModelRegistry.add(ProcessMonitorModel);

export class ProcessMonitorApp extends App {
  static registryName = 'ProcessMonitorApp';
  static AppProps = {
    pendingOperationProjects: ProjectArrayApp,
  };

  static Model = ProcessMonitorModel;
}
AppRegistry.add(ProcessMonitorApp);
